import { SvgIcon, type SvgIconProps } from "@mui/material";
import React from "react";

export const Mercer: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} className="-translate-x-px">
      <svg width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M62.5386 27.8884L51.1394 21.328C50.3356 20.8907 49.0203 20.8907 48.2165 21.328L16.7226 39.4784L34.1137 26.0661L25.7835 21.328C24.9797 20.8907 23.6644 20.8907 22.8606 21.328L11.4614 27.8884C10.6576 28.3257 10 29.492 10 30.4396V43.5604C10 44.508 10.6576 45.6014 11.4614 46.1116L22.8606 52.672C23.6644 53.1093 24.9797 53.1093 25.7835 52.672L57.2774 34.5216L39.8863 47.861L48.2165 52.672C49.0203 53.1093 50.3356 53.1093 51.1394 52.672L62.5386 46.1116C63.3424 45.6743 64 44.508 64 43.5604V30.4396C64 29.492 63.3424 28.3257 62.5386 27.8884Z"
          fill="current"
        />
      </svg>
    </SvgIcon>
  );
};
